<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Proctor Monitoring</span>
        </v-row>
        <br />
        <v-card>
            <v-card-title class="justify-center heading">
                <h4>Proctor Monitoring</h4>
            </v-card-title>
            <div class="box">
                <v-card-text>
                    <v-row>
                        <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                            <label class="bold">Exam</label>
                            <v-autocomplete
                                :items="exam_list"
                                item-value="exam_id"
                                item-text="exam_name"
                                v-model="exam"
                                @change="findDates()"
                                :rules="[(v) => !!v || 'required']"
                                outlined
                                dense
                                placeholder="Select Exam"
                                class="select"
                            ></v-autocomplete>
                        </v-col>
                        <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                            <label class="bold">Exam Date</label>
                            <v-select :items="dates" outlined dense placeholder="Select Exam Date" v-model="date" @change="findSlot()" :rules="[(v) => !!v || 'required']" class="select"></v-select>
                        </v-col>
                        <v-col xs="12" sm="12" lg="2" md="6" cols="12">
                            <label class="bold">Slot No. </label>
                            <v-select :items="slot_list" item-value="id" item-text="slotNo" outlined dense @change="findtime()" placeholder="Select Slot" v-model="slotNo" :rules="[(v) => !!v || 'required']" class="select"></v-select>
                        </v-col>
                        <v-col xs="12" sm="12" lg="2" md="6" cols="12">
                            <label class="bold">Start Time </label>
                            <v-text-field readonly v-model="startTime" outlined dense class="select"></v-text-field>
                        </v-col>
                        <v-col xs="12" sm="12" lg="2" md="6" cols="12">
                            <label class="bold">End Time</label>
                            <v-text-field readonly v-model="endTime" outlined dense class="select"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn class="mb-2 button btn" @click="fetchdetails()">Fetch</v-btn>
                </v-card-actions>
            </div>
            <v-row class="justify-center" v-if="proctor_list != ''">
                <v-col cols="12">
                    <!-- <v-data-table :headers="headers1" :items="proctor_list" :item-value="proctor_id" sort-by class="elevation-1 mytable" :search="search">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                        <template v-slot:item.contactno="{ item }">
                            <span v-if="item.contactno != ''">{{ item.contactno }}</span>
                            <span style="color: grey;" v-else>Contact No. not found !</span>
                        </template>
                        <template v-slot:item.count="{ item }">
                            <span @click="getStudentList(item)" style="cursor: pointer; text-decoration: underline;"><a>#{{ item.student_count }}</a></span>
                        </template>
                        <template v-slot:item.delete="{ item }">
                            <span v-if="item.student_count != ''">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="gray" v-bind="attrs" v-on="on">mdi-delete-circle</v-icon>
                                    </template>
                                    <span>This proctor cannot be deleted!</span>
                                </v-tooltip>
                            </span>
                            <span v-else>
                                <v-icon color="red" class="mr-2" @click="deleteProctor(item)">mdi-delete-circle</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.chat_report="{ item }">
                            <span>
                                <v-btn small class="button" v-on="on" @click="chatReport(item)">Chat History</v-btn>
                            </span>
                        </template>
                    </v-data-table> -->
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Proctor Monitoring</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                      <span class="refresh">  Refresh Live Data </span>
                         <v-btn icon color="black" @click="fetchdetails()">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <download-excel class="mar" :data="proctor_list" :fields="table_fields" worksheet="proctor_list" name="Proctor Monitoring Report.xls">
                            <v-btn color="success" dark class="mb-2"> Export<v-icon dark>mdi-file-excel</v-icon> </v-btn>
                        </download-excel>
                    </v-toolbar>
                    <v-simple-table class="mytable">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Sr.No.
                                    </th>
                                    <th class="text-left">
                                        Proctor Code
                                    </th>
                                    <th class="text-left">
                                        Proctor Name
                                    </th>
                                    <th class="text-left">
                                        Proctor Contact No.
                                    </th>
                                    <th class="text-left">
                                        Student Count
                                    </th>
                                    <th class="text-left">
                                        Chat Report
                                    </th>
                                    <th class="text-center">
                                        Dashboard
                                    </th>
                                    <!-- <th class="text-left">
                                       
                                         <v-tooltip left color="black">
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" icon color="white" @click="fetchdetails()">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Refresh Chat History!</span>
                                        </v-tooltip>
                                    </th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in proctor_list" :key="item.proctor_id">
                                    <td>{{ item.srno }}</td>
                                    <td>{{ item.proctor_code }}</td>
                                    <td>{{ item.proctor_name }}</td>
                                    <td>{{ item.contactno }}</td>
                                    <td>
                                        <span @click="getStudentList(item)" style="cursor: pointer; text-decoration: underline;"><a>#{{ item.student_count }}</a></span>
                                    </td>
                                    <td>
                                        <span>
                                            <v-btn small class="button" v-on="on" @click="chatReport(item)">Chat History</v-btn>
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            <v-btn small class="button" v-on="on" @click="proceed(item)">View Proctor Dashboard</v-btn>
                                        </span>
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            <template>
                <v-row justify="center">
                    <v-dialog v-model="studentcount" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="studentcount = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>Student Count</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <!-- <v-btn dark text @click="studentcount = false"> Save </v-btn> -->
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-row class="justify-center" v-if="proctor_list != ''">
                                <v-col cols="12">
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Student Count</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                        <download-excel class="mar" :data="student_list" :fields="table_fields_for_student_count" worksheet="student_list" name="Student Count Report.xls">
                                            <v-btn color="success" dark class="mb-2"> Export<v-icon dark>mdi-file-excel</v-icon> </v-btn>
                                        </download-excel>
                                    </v-toolbar>
                                    <v-data-table :headers="headers" :items="student_list" :item-value="student_name" sort-by class="elevation-1 mytable" :search="search">
                                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                        <template v-slot:item.chat_history="{ item }">
                                            <span>
                                                <v-btn small class="button" v-on="on" @click="LearnerchatReport(item)">Chat History</v-btn>
                                            </span>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="chat_dialog" max-width="700px">
                        <v-card>
                            <v-card-title class="heading mb-3">
                                Chat History
                                <v-spacer></v-spacer>
                                <div>
                                    <v-btn icon color="white" @click="LearnerchatReport(refresh_details)">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <div :style="{height:chat_div + 'px'}" class="chat-div" ref="messagesContainer">
                                    <!-- <div v-if="!proctor_avability" class="center" :style="{paddingTop:pt + 'px'}">
                        <p>No Faculty available for chatting.</p>
                    </div> -->
                                    <div v-if="chat_list.length == 0" class="first-msg" :style="{paddingTop:pt + 'px'}">
                                        <p>Data not found!!!</p>
                                    </div>
                                    <div v-for="(msg,index) in chat_list" :key="index">
                                        <div v-if="msg.proctor_msg" class="grid-s">
                                            <div id="p-chat-btn">
                                                <div>
                                                    <div class="sender-name">{{msg.proctor_name}}</div>
                                                    <div class="stud-msg-text">{{msg.msg}}</div>
                                                    <div class="time">{{msg.timeDate}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!msg.proctor_msg" class="grid-e">
                                            <div id="stud-chat-btn">
                                                <div>
                                                    <div class="sender-name">{{msg.stud_name}}</div>
                                                    <div class="stud-msg-text">{{msg.msg}}</div>
                                                </div>
                                                <div class="time">{{msg.timeDate}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="button-cancel" text @click="chat_dialog = false">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
        </v-card>
        <v-dialog v-model="all_chat_dialog" width="700">
            <v-card>
                <v-card-title class="heading mb-3">
                    Proctor Chat History
                    <v-spacer></v-spacer>
                    <div>
                        <v-btn icon color="white" @click="chatReport(refresh_details_all)">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>

                <v-card-text>
                    <div :style="{height:chat_div + 'px'}" class="chat-div" ref="messagesContainer">
                        <!-- <div v-if="!proctor_avability" class="center" :style="{paddingTop:pt + 'px'}">
                        <p>No Faculty available for chatting.</p>
                    </div> -->
                        <div v-if="all_chat_list.length == 0" class="first-msg" :style="{paddingTop:pt + 'px'}">
                            <p>Data not found!!!</p>
                        </div>
                        <div v-for="(msg,index) in all_chat_list" :key="index">
                            <div v-if="msg.proctor_msg" class="grid-s">
                                <div id="p-chat-btn">
                                    <div>
                                        <div class="sender-name">{{msg.proctor_name}}</div>
                                        <div class="stud-msg-text">{{msg.msg}}</div>
                                        <div class="time">{{msg.timeDate}}</div>
                                        <div class="tostud" v-if="msg.stud_name==null">To : All Students</div>
                                        <div class="tostud" v-else>To : {{msg.stud_name}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!msg.proctor_msg" class="grid-e">
                                <div id="stud-chat-btn">
                                    <div>
                                        <div class="sender-name">{{msg.stud_name}}</div>
                                        <div class="stud-msg-text">{{msg.msg}}</div>
                                    </div>
                                    <div class="time">{{msg.timeDate}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button-cancel" text @click="all_chat_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <template>
            <v-row justify="center">
                <v-dialog v-model="proctoring_data" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar class="heading">
                            <!-- <v-btn icon dark @click="proctoring_data = false">
                <v-icon>mdi-close</v-icon>
              </v-btn> -->
                            <v-toolbar-title style="color: white;">Student Data</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text @click="proctoring_data = false">Close</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-row>
                            <!-- <router-link to="coe-proctor-dashboard"></router-link> -->
                            <proctorDashboard ref="childComponent"></proctorDashboard>
                            <!-- <v-col sm="2" v-for="ph in photoPath" :key="ph">
                     <img v-bind:src="ph" height="100px" width="100px" />
                     </v-col> -->
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import moment from "moment";
    import proctorDashboard from "./COEProctorDashboard";

    export default {
        data() {
            return {
                proctoring_data: false,
                exam_list: "",
                exam: "",
                dates: "",
                date: "",
                slot_list: "",
                slotNo: "",
                startTime: "",
                endTime: "",
                proctor_list: [],
                snackbar_msg: "",
                color: "",
                refresh_details: "",
                refresh_details_all: "",
                snackbar: false,
                chat_dialog: false,
                all_chat_dialog: false,
                search: "",
                studentcount: false,
                student_list: [],
                chat_list: [],
                all_chat_list: [],
                headers1: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Proctor Code", value: "proctor_code" },
                    { text: "Proctor Name", value: "proctor_name" },
                    { text: "Proctor Contact No.", value: "contactno" },
                    { text: "# Students", value: "count" },
                    { text: "Action", value: "delete" },
                    { text: "Chat Report", value: "chat_report" },
                ],
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Registration No.", value: "registration_no" },
                    { text: "Student Name", value: "student_name" },
                    { text: "Chat History", value: "chat_history" },
                ],
                table_fields: {
                    "Sr.No.": "srno",
                    "Proctor Code": "proctor_code",
                    "Proctor Name": "proctor_name",
                    "Proctor Contact No.": "contactno",
                    "Student Count": "student_count",
                },
                table_fields_for_student_count: {
                    "Sr.No.": "srno",
                    "Registration No.": "registration_no",
                    "Student Name": "student_name",
                },
            };
        },
        components: {
            proctorDashboard,
        },
        mounted() {
            axios
                .get("/COE/proctorMonitoring")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.exam_list = res.data.Exam_List;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            findDates() {
                const data = {
                    examId: this.exam,
                };
                console.log("data: " + data.examId);
                axios
                    .post("/COE/getDateforProctorMonitoring", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.dates = res.data.dates;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            findSlot() {
                let formatDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                const data = {
                    examId: this.exam,
                    date: formatDate,
                };
                console.log("DATA: " + data.examId + "" + data.date);
                axios
                    .post("/COE/getSlotsforProctorMonitoring", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.slot_list = res.data.slot;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            findtime() {
                const data = {
                    slot: this.slotNo,
                };
                axios
                    .post("/COE/getSlotTimesforProctorMonitoring", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.endTime = res.data.end_time;
                            this.startTime = res.data.start_time;
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {});
            },
            fetchdetails() {
                let newDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                if (this.exam == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam.!");
                    return;
                }
                if (this.slotNo == "") {
                    this.showSnackbar("#b71c1c", "Please Select Slot No.!");
                    return;
                }
                const data = {
                    slot: this.slotNo,
                    exam: this.exam,
                    date: newDate,
                };
                console.log("data" + data.slot + " " + data.exam + " " + data.date);
                axios
                    .post("/COE/fetchProctorDetails", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.proctor_list == "") {
                                this.showSnackbar("#b71c1c", "No Data found!");
                            } else {
                                this.proctor_list = res.data.proctor_list;
                            }
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            getStudentList(item) {
                console.log("item id", item.proctor_id);
                const data = {
                    id: item.proctor_id,
                };
                axios
                    .post("/COE/getStudents", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            (this.studentcount = true), (this.student_list = res.data.Student_list);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            deleteProctor(item) {
                console.log("item.proctor_id: " + item.proctor_id);
                if (confirm("Are you sure you want to Delete the Proctor?")) {
                    const data = {
                        proctor_session_id: item.proctor_id,
                    };
                    axios
                        .post("/COE/deleteProctor", data)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.fetchdetails();
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        })
                        .finally(() => {});
                }
            },
            chatReport(item) {
                this.refresh_details_all = item;
                this.all_chat_dialog = true;
                const data = {
                    proctor_session_id: item.proctor_id,
                };
                axios
                    .post("/COE/chatReport", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.fetchdetails();
                            this.all_chat_list = res.data.all_chat_history;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            LearnerchatReport(item) {
                this.refresh_details = item;
                this.chat_dialog = true;
                const data = {
                    learner_reg_no: item.registration_no,
                };
                axios
                    .post("/COE/chatReport", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.chat_list = res.data.history;
                            this.fetchdetails();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            proceed(val) {
                (this.proctoring_data = true), console.log("val: " + val.proctor_id);
                this.$store.commit("setcoe_proctor_dashboard_id", val.proctor_id);
                this.$refs.childComponent.onload();
                // this.$router.push({ name: 'coe-proctor-dashboard', target:"_blank"})
            },
        },
    };
</script>

<style>
    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }
    .center {
        text-align: center;
        color: red;
    }
    .first-msg {
        text-align: center;
        padding: 0rem 3rem 0rem 3rem;
        color: green;
    }
    .time {
        float: right;
        font-size: 10px;
        padding-right: 0.7rem;
        color: gray;
    }
    .tostud {
        float: right;
        font-size: 12px;
        padding-right: 0.7rem;
        color: gray;
    }
    .sender-name {
        padding: 0rem 0.7rem 0rem 0.7rem;
        background: #09809c85;
        color: white;
        font-size: 12px;
    }
    .chat-div {
        overflow: scroll;
        overflow-x: hidden;
        /* background-color:#deeff5; */
    }
    .chat-div::-webkit-scrollbar {
        display: none;
    }
    .grid-s {
        display: grid;
        justify-content: start;
        width: 80%;
        float: left;
    }
    .grid-e {
        display: grid;
        justify-content: end;
        width: 80%;
        float: right;
    }
    .stud-msg-text {
        padding: 0.2rem 0.7rem 0.2rem 0.7rem;
    }
    /* .stud-msg{
    display: flex;
    justify-content: flex-end;
    background: #deeff5;
    border-radius: 5px;
    float: right;
} */
    #stud-chat-btn {
        float: right;
        background-color: #deeff5;
        /* background-color:white; */
        border-radius: 4px;
        position: relative;
        margin-bottom: 1rem;
        width: fit-content;
        justify-content: end;
        height: fit-content;
    }
    #stud-chat-btn:after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        right: 5px;
        bottom: -10px;
        border-left: 10px solid transparent;
        border-right: 1px solid transparent;
        border-top: 10px solid#deeff5;
    }

    #p-chat-btn {
        float: right;
        background-color: #d3ffcf;
        /* background-color:white; */
        border-radius: 4px;
        position: relative;
        margin-bottom: 1rem;
        width: fit-content;
        justify-content: end;
        height: fit-content;
    }
    #p-chat-btn:after {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        left: 5px;
        bottom: -10px;
        border-right: 10px solid transparent;
        border-left: 1px solid transparent;
        border-top: 10px solid #d3ffcf;
    }
    .msg {
        padding: 0rem 1rem 0rem 1rem;
        bottom: 0;
        position: fixed;
        width: inherit;
    }
    .chat-icon {
        bottom: 0px;
        right: 0px;
        position: fixed !important;
        font-size: 100px;
        z-index: 1;
        cursor: pointer;
    }
    .main {
        border: 2px solid hsla(190, 99%, 30%, 1);
        border-radius: 5px;
    }
    /* .show {
        background-color: red;
    }
    .slide-enter-active,
    .slide-leave-active {
        transition: all 0.6s ease;
    }
    .slide-enter,
    .slide-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    } */
    .chat-box {
        /* display: grid; */
        height: -webkit-fill-available !important;
        height: auto;
        padding: 3.5rem 0.6rem 0.3rem 0.6rem;
        width: 22rem;
        /* height: 10rem; */
        background: white;
        /* justify-content: end; */
    }
    .chat-box2 {
        width: 22rem;
        /* height: 15rem;
    background: lightgrey; */
    }
    .icon {
        font-size: 25px;
        padding-top: 0.5rem;
        color: white;
        margin-right: 17rem;
    }
    .main-h {
        display: flex;
        /* justify-content: space-between; */
        padding: 0rem 1rem 0rem 1rem;
        position: fixed;
        /* top: 0; */
        width: 100%;
        z-index: 1;
        height: 3.5rem;
        background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);
    }

    .main-h1 {
        display: flex;
        /* justify-content: space-between; */
        padding: 0rem 1rem 0rem 1rem;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 1;
        height: 3.5rem;
        background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%) !important;
    }
     .refresh {
        font-size: 11px;
        color: green;
    }
</style>
